import styled from "styled-components";

import AtlaskitTextfield from "@atlaskit/textfield";
import AtlaskitSelect, {
  AsyncSelect as AtlaskitAsyncSelect,
} from "@atlaskit/select";

export const TextField = styled(AtlaskitTextfield)`
  border-color: ${({ theme }) => theme.bg.primary} !important;
  background: ${({ theme }) => theme.bg.primary};
  border-radius: 8px;

  input {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px !important;
    color: ${({ theme }) => theme.text.text} !important;
  }

  svg {
    color: ${({ theme }) => theme.text.text};
  }
`;

export const Select = styled(AtlaskitSelect)`
  font-size: 14px;

  div[class*="control"] {
    border-color: ${({ theme }) => theme.bg.primary} !important;
    background: ${({ theme }) => theme.bg.primary};
  }
  div[class*="menu"] {
    margin-left: 2px;
  }
`;

export const AsyncSelect = styled(AtlaskitAsyncSelect)`
  font-size: 14px;

  div[class*="control"] {
    border-color: ${({ theme }) => theme.bg.primary} !important;
    background: ${({ theme }) => theme.bg.primary};
  }
  div[class*="menu"] {
    margin-left: 2px;
  }
`;
